export default __webpack_public_path__ + "static/media/subhajit.3ca00162.png";